import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

import { CustomValidatorChipsComponent } from './custom-validator-chips/custom-validator-chips.component';
import { InputChipsComponent } from './input-chips/input-chips.component';

@NgModule({
  declarations: [InputChipsComponent, CustomValidatorChipsComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    ReactiveFormsModule,
  ],
  exports: [InputChipsComponent, CustomValidatorChipsComponent],
})
export class ChipsModule {}
